import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Button, DescriptiveText} from '../../../shared';
import {_getUnreadReports} from '../../../shared/store';
import axiosInstance from '../../../shared/utils/axios';

const reportName = 'Previously Mapped Account Codes';

/**
 * Previously Mapped Account Codes Report.
 * @module advisor/components/reports/PreviouslyMappedAccountCodesReport
 */
function PreviouslyMappedAccountCodesReport(props) {
  const {
    report,
    session,
    unreadReports,
    unreadReportsTimeoutID,
    reportPageVisitTimestamp,
    getUnreadReports,
  } = props;

  const [step, setStep] = React.useState(1);
  const [message, setMessage] = React.useState('');

  const paramFirmID = report.parameters.find(o => o.name === 'firmID');
  const parameters = [
    {
      id: paramFirmID.id,
      value: session.profile.firm.id,
    },
  ];

  return message ? (
    <DescriptiveText>{message}</DescriptiveText>
  ) : (
    <div>
      <DescriptiveText>
        The Previously Mapped Account Codes Report displays a list of accounts where the account code has
        been changed by the institution, and the new account code has not yet been mapped to an advisor.
      </DescriptiveText>
      <Button
        importance={'secondary'}
        size={'md'}
        label={'Generate'}
        action={() => {
          if (session.profile.role !== 'FIRMMGR') {
            return;
          }

          axiosInstance.post(`/reports/${reportName}`, {parameters})
            .then(() => {
              setMessage('Success! Your report is being generated and you will receive a notification when it is ready.');
              setStep(step + 1);

              getUnreadReports(
                unreadReportsTimeoutID,
                unreadReports,
                reportPageVisitTimestamp,
                30000
              );
            })
            .catch((err) => {
              setMessage('Report failed to generate ' + err.response.data.error.msg);
              setStep(step + 1);
            });
        }}
      />
    </div>
  );
}

const mapStateToProps = state => ({
  session: state.session,
  unreadReportsTimeoutID: state.badges.unreadReportsTimeoutID,
  unreadReports: state.badges.unreadReports,
  reportPageVisitTimestamp: state.badges.reportPageVisitTimestamp,
});

const mapDispatchToProps = dispatch => ({
  getUnreadReports: (timeoutID, unread, timestamp, interval) => dispatch(_getUnreadReports(timeoutID, unread, timestamp, interval)),
});

PreviouslyMappedAccountCodesReport.propTypes = {
  /**
   * Is from Session Reducer
   */
  session: PropTypes.shape({profile: PropTypes.object}).isRequired,
  /**
   * Are from badges reducer
   */
  getUnreadReports: PropTypes.func,
  unreadReportsTimeoutID: PropTypes.object,
  unreadReports: PropTypes.object,
  reportPageVisitTimestamp: PropTypes.object,
  report: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviouslyMappedAccountCodesReport);
